
    // --- Configuration ---
    // Required: Add your Site ID and Key
    var iecSiteId = 1357;
    var iecSiteKey = '0e38783d5109a70bb4a8a660be47eb87';
    // Optional: For use with HTML Options B and C
    var brandProfileUrl = 'https://iequalchange.com/brands/dimple-color'; // Your brand's profile URL on i=Change
    var brandName = 'DimpleColor'; // Your brand's name
    // Advanced: To combine totals, add other Site IDs here. E.g., ['111', '222']
    var relatedSiteIDs = ['1357','1355']; 
    // ---------------------
    // Static asset for Option B. Do not change.
    var iecIconUrl = 'https://share.iequalchange.com/images/assets/i_change_icon.svg';
    function loadLiveTotal() {
        var firstImageElement = document.querySelector(".iec-image");
        var logoChoice = 1; // Default logo
        // Check for a logo choice specified in the HTML for the first instance of Option C
        if (firstImageElement && firstImageElement.getAttribute('data-logo-choice')) {
            logoChoice = firstImageElement.getAttribute('data-logo-choice');
        }
        
        var baseUrl = 'https://share.iequalchange.com/public/api/donations/livetotal?logo=' + logoChoice;
        var relatedIdsQuery = relatedSiteIDs.map(id => 'RelatedSiteIDs[]=' + id).join('&');
        var iecUrl = relatedIdsQuery ? baseUrl + '&' + relatedIdsQuery : baseUrl;
        var xmlhttp = new XMLHttpRequest();
        xmlhttp.onreadystatechange = function () {
            if (xmlhttp.readyState == XMLHttpRequest.DONE) {
                if (xmlhttp.status == 200) {
                    var data = JSON.parse(xmlhttp.response);
                    // Format number to be rounded and include comma separator
                    var formattedDonation = Math.round(data.donation).toLocaleString('en-US');
                    
                    // Populate the donation amount in ALL counter widgets
                    document.querySelectorAll(".i-donation").forEach(function(el) {
                        el.innerHTML = formattedDonation;
                    });
                } else {
                    console.error('i=Change Counter Error: ' + xmlhttp.status, xmlhttp);
                }
            }
        };
        xmlhttp.open("GET", iecUrl, true);
        var base64Credentials = btoa(iecSiteId + ":" + iecSiteKey);
        xmlhttp.setRequestHeader("Authorization", "Basic " + base64Credentials);
        xmlhttp.setRequestHeader("Accept", "*/*");
        xmlhttp.send();
    }
    // Check if any counter elements exist on the page before running
    if (document.querySelector(".i-donation")) {
        loadLiveTotal();
    }
